// 导出逻辑
import {Message} from "element-ui";
import {request} from "@/config/request";
import {downloadFile} from "@/utils/common";

export async function exportExcel(codes, api) {
  if(!codes || codes.length === 0) {
    Message.warning("请选择要导出的数据");
    return;
  }
  try {
    const res = await request(api,codes, {isJson: true});
    downloadFile(res?.url);
  } catch (e) {
    console.log(e);
  }
}
